export default function errorSlpBlock(invalid) {
  var errors = [];
  if (invalid) {
    Object.keys(invalid).forEach(function (key) {
      errors.push(key);
    });
  }
  return { error_field: errors.join() };
};
